module.exports = __webpack_public_path__ + "img/contacts_phone1.dcb5a3ef.svg";